import BaseAPI from './base.api';
import { TSMSProviderTemplatePayload, TSMSTemplate } from 'components/FlowBuilder/FlowSidePanels/types';

class SMSAPI extends BaseAPI {
  private ROUTES = {
    smsTemplates: 'integrations/webhook/sms/twilio/templates',
  };

  private queryParams = {
    limit: 0,
    offset: 0,
  };

  getSMSTemplates(params = {}): Promise<TSMSTemplate[]> {
    const queryParams = { ...this.queryParams, ...params };
    return this.GET(this.ROUTES.smsTemplates, queryParams);
  }

  // Fetch a single Twilio SMS template payload (including its body, title, placeholders)
  getSMSTemplate(templateId: string): Promise<TSMSProviderTemplatePayload> {
    return this.GET(this.buildURL(`${this.ROUTES.smsTemplates}/:templateId`, { templateId }));
  }
}

const smsService = new SMSAPI();

export default smsService;
